export const BaseURL = process.env.REACT_APP_BASE_URL;
export const FrontendURL = process.env.REACT_APP_FRONTEND_URL;

const API_URL = `${BaseURL}/api/`;

// local Images
// export const ImageURL = `${BaseURL}/uploads`;
// export const PropertyImageURL = `${BaseURL}/uploads/property`;
// export const TeamImageURL = `${BaseURL}/uploads/team`;

const API = {
  login: API_URL + "authentication/login",
  property: API_URL + "property",
  product: API_URL + "product",
  enquiry: API_URL + "enquiry",
};
export default API;
